import React, { FC, useCallback, useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import { LOCATION_DEFAULT_TITLE_2 } from '@rover/constants/src/location/location.constants';
import { Box, Button, Flex } from '@rover/kibble/core';
import Location from '@rover/react-lib/src/pages/search/SearchPage/components/Filters/Location';
import type { ApiGroomingSearchRetrieveParams } from '@rover/rsdk/src/apiClient/latest/model/apiGroomingSearchRetrieveParams';

import { getGroomingSearchPageUrl } from '../utils/groomingSearch';

type Props = {
  initialParams: ApiGroomingSearchRetrieveParams;
};

const GroomingSearchForm: FC<Props> = ({ initialParams }) => {
  const { i18n } = useLingui();
  const [params, setParams] = useState<ApiGroomingSearchRetrieveParams>(initialParams);

  const onLocationChange = useCallback<React.ComponentProps<typeof Location>['onChange']>(
    ({ location, centerlat, centerlng, locationType }) => {
      const latitude = parseFloat(String(centerlat));
      const longitude = parseFloat(String(centerlng));
      setParams((previous) => ({
        ...previous,
        location: location || previous.location,
        locationType: locationType || previous.locationType,
        centerlat: Number.isFinite(latitude) ? latitude : previous.centerlat,
        centerlng: Number.isFinite(longitude) ? longitude : previous.centerlng,
      }));
    },
    []
  );

  const onLocationClear = useCallback(() => setParams(initialParams), [initialParams]);

  return (
    <Flex flexDirection="column">
      <Box my={['4x', '6x']}>
        <Location
          label={i18n._(LOCATION_DEFAULT_TITLE_2)}
          location={params.location}
          onChange={onLocationChange}
          onClear={onLocationClear}
          locationInputId="grooming-landing-search-form-location"
        />
      </Box>
      <Button
        variant="primary"
        size="large"
        fullWidth
        mt="4x"
        href={getGroomingSearchPageUrl(params)}
      >
        {/* DEV-156190: Translate */}
        Search
      </Button>
    </Flex>
  );
};

export default GroomingSearchForm;
